export default __webpack_public_path__ + "static/about-7-0a7ed076a744bd3aa969cb253e06d598.png";